module.exports = __webpack_public_path__ + "img/form2.1e76a59a.png";